import type { SlugNode } from '@/lib/slug-rewrites';

/** es/ca/it are deliberately the words `old/contact.meta.ts` served — see slug-rewrites. */
export const routeName = 'contact';
export const slugs: Record<string, string> = {
	es: 'contacto',
	en: 'contact',
	ca: 'contacte',
	fr: 'contact',
	it: 'contatto',
};

/**
 * Keyed by the internal param value, so no caller needs the locale. `collaborate` is absent on purpose:
 * it is the default tab, so it owns the bare `/contacto/ong`.
 */
export const children: Record<string, SlugNode> = {
	company: { slugs: { es: 'empresas', en: 'companies', ca: 'empreses', fr: 'entreprises', it: 'aziende' } },
	ngo: {
		slugs: { es: 'ong', en: 'ngos', ca: 'ong', fr: 'ong', it: 'ong' },
		children: {
			enquire: { slugs: { es: 'consulta', en: 'enquiry', ca: 'consulta', fr: 'demande', it: 'richiesta' } },
		},
	},
	donor: { slugs: { es: 'donantes', en: 'donors', ca: 'donants', fr: 'donateurs', it: 'donatori' } },
	press: { slugs: { es: 'prensa', en: 'press', ca: 'premsa', fr: 'presse', it: 'stampa' } },
};

export const sitemap = { changefreq: 'monthly', priority: '0.7', lastmod: '2026-08-21' };
